import script from "./ImpersonateTenant.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImpersonateTenant.vue?vue&type=script&lang=ts&setup=true"

import "./ImpersonateTenant.vue?vue&type=style&index=0&id=255e9664&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-255e9664"]])

export default __exports__